import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function InfoSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M18.4368667 9.8082c0 1.236-1.002 2.2373333-2.2373334 2.2373333-1.236 0-2.2373333-1.0013333-2.2373333-2.2373333s1.0013333-2.23733333 2.2373333-2.23733333c1.2353334 0 2.2373334 1.00133333 2.2373334 2.23733333zm-4.0273334 16.0673333h3.5793334V15.1362h-3.5793334v10.7393333zm1.79-25.2833333C7.57953333.5922.58286667 7.5882.58286667 16.2082S7.57953333 31.8248667 16.1995333 31.8248667c8.62 0 15.616-6.9966667 15.616-15.6166667 0-8.62-6.996-15.616-15.616-15.616z"
        />
      </g>
    </svg>
  )
}

InfoSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
